// The Accelerator's groups on Recordings and dates (AdminRecordings.dc.html's Cohorts and dates draws a
// card per group with its sessions, Add a session and the WhatsApp link; adding, renaming and removing a
// group, and a session for every group, are undrawn: the map's critic, build_now 4). Owner and admin;
// support and a host see the cards as they are. Each write is a direct write the database decides:
// cohorts and sessions are owner's and admin's, a group's name is 1 to 80 characters and unique on its
// product, and a group with anyone, any session, recording or price behind it can't be removed (its
// rows refer to it), so the database refuses that and the line says why.
import { useId, useState } from 'react'
import { Button, ConfirmPanel, Dot, Field, TextInput } from '../ui/index.js'
import { GROUPS, nextGroup, addGroupLabel } from './words.js'
import { addGroup, renameGroup, removeGroup, addEverySession } from './data.js'
import '../../styles/admin-mastermind.css'

// Rename, in a group card's head (owner, admin)
export function RenameButton({ card, open, onToggle }) {
  return (
    <Button size="xs" aria-expanded={open} aria-label={`${GROUPS.rename}: ${card.cohort.name}`} onClick={onToggle}>{GROUPS.rename}</Button>
  )
}

// The name box under a group card's head
export function RenameRow({ card, api, reload, onDone, onCancel }) {
  const [name, setName] = useState(card.cohort.name)
  const [busy, setBusy] = useState(false)
  const [problem, setProblem] = useState(null)
  async function save() {
    if (busy) return
    setBusy(true); setProblem(null)
    try {
      const row = await renameGroup(api, { cohortId: card.cohort.id, name })
      await reload()
      onDone(GROUPS.renamed(row.name))
    } catch (e) {
      setProblem(e.message)
      setBusy(false)
    }
  }
  return (
    <div className="amm-rename" role="group" aria-label={`${GROUPS.rename}: ${card.cohort.name}`}>
      <Field label={GROUPS.renameLabel} plain error={problem}>
        {props => <TextInput {...props} value={name} onChange={v => { setName(v); setProblem(null) }} maxLength={80} autoFocus />}
      </Field>
      <span className="amm-row-actions">
        <Button kind="ink" size="sm" busy={busy} disabled={!name.trim() || name.trim() === card.cohort.name} onClick={save}>{GROUPS.renameSave}</Button>
        <Button size="sm" onClick={onCancel} disabled={busy}>{GROUPS.cancel}</Button>
      </span>
    </div>
  )
}

// Remove the group, in its card's foot: only for a group with no sessions or recordings on screen; the
// database refuses one anyone is in, or a price points at
export function RemoveGroup({ card, api, data, reload, onLine }) {
  const [asking, setAsking] = useState(false)
  const [busy, setBusy] = useState(false)
  const [problem, setProblem] = useState(null)
  const used = card.rows.length > 0 || (data.recordings || []).some(r => r.cohort_id === card.cohort.id)
  if (used) return null
  async function go() {
    setBusy(true); setProblem(null)
    try {
      await removeGroup(api, { cohortId: card.cohort.id, name: card.cohort.name })
      onLine({ text: GROUPS.removed(card.cohort.name), product: card.product.id })
      await reload()
    } catch (e) {
      setProblem(e.message)
      setBusy(false)
    }
  }
  if (!asking) return <Button size="sm" onClick={() => setAsking(true)}>{GROUPS.remove}</Button>
  return (
    <ConfirmPanel text={GROUPS.removeConfirm(card.cohort.name)} confirmLabel={GROUPS.removeYes} cancelLabel={GROUPS.removeNo}
      busy={busy} error={problem} onConfirm={go} onCancel={() => { setAsking(false); setProblem(null) }} />
  )
}

// Under a mastermind's group cards: Add group 3, and Add a session for every group (owner, admin)
export function GroupsFoot({ product, data, api, personId, reload, line, onLine }) {
  const [busy, setBusy] = useState(null)
  const ids = useId()
  const next = nextGroup(product, data.cohorts)
  const hasEvery = (data.sessions || []).some(s => s.product_id === product.id && !s.cohort_id)

  // the line is the screen's, not this box's: a new group's card comes last, so this box moves after it
  async function run(kind, fn, text) {
    if (busy) return
    setBusy(kind); onLine(null)
    try {
      await fn()
      await reload()
      onLine({ text, product: product.id })
    } catch (e) {
      onLine({ bad: true, text: e.message, product: product.id })
    } finally {
      setBusy(null)
    }
  }
  const shown = line?.product === product.id ? line : null
  return (
    <div className="amm-groups-foot" role="group" aria-labelledby={`${ids}-h`}>
      <span className="amm-groups-name" id={`${ids}-h`}><Dot product={product} />{GROUPS.groupsOf(product.name)}</span>
      <Button size="sm" busy={busy === 'group'} disabled={Boolean(busy)}
        onClick={() => run('group', () => addGroup(api, { product, cohorts: data.cohorts, name: next.name, number: next.number, personId }), GROUPS.added(next.name))}>
        {addGroupLabel(next.name)}
      </Button>
      {!hasEvery && (
        <Button size="sm" busy={busy === 'every'} disabled={Boolean(busy)}
          onClick={() => run('every', () => addEverySession(api, { product, sessions: data.sessions, personId }), GROUPS.addedEvery)}>
          {GROUPS.addEvery}
        </Button>
      )}
      {shown && <span className={shown.bad ? 'ad-error' : 'adc-flash'} role={shown.bad ? 'alert' : 'status'}>{shown.text}</span>}
    </div>
  )
}
